import { z } from 'zod';

import { placeSchema } from './Place.ts';

export const vehicleMessageSchema = z.object({
  received_at: z.string(),
  message_type: z.string(),
  provider_identifier: z.string(),
  geo_position: z.object({
    lat: z.number(),
    lon: z.number(),
  }),
  speed: z.number(),
  battery: z.object({
    level: z.union([z.string(), z.number()]),
    charging: z.boolean(),
  }),
  robot_mode: z.string(),
  supervision_mode: z.string(),
  connection_status: z.string(),
  door_status: z.string().optional(),
});
export const missionMessageSchema = z.object({
  received_at: z.string(),
  message_type: z.string(),
  provider_id: z.string(),
  vehicle_id: z.string(),
  territory_id: z.number(),
  created_by: z.string(),
  steps: z.array(z.any()).optional(),
  lifecycle: z.string().optional(),
  progress: z.number().optional(),
  estimated_distance: z.number().optional(),
  estimated_duration: z.string().optional(),
  remaining_distance: z.number().optional(),
  remaining_duration: z.string().optional(),
  raw_data: z.record(z.string(), z.any()).optional(),
});
export const roadmapMessageSchema = z.object({
  message_type: z.string(),
  vehicle: z.string(),
  ride_id: z.number(),
  shift_id: z.number(),
  dispatch_provider_vehicle_id: z.number(),
  places: z.array(placeSchema),
});
export const alertMessageSchema = z.object({
  type: z.string(),
  code: z.number(),
  content_object_display_name: z.string(),
  events: z.number(),
  extra: z.record(z.string(), z.string()),
  lifecycle: z.string(),
  source: z.string(),
});

export type VehicleMessage = z.infer<typeof vehicleMessageSchema>;
export type MissionMessage = z.infer<typeof missionMessageSchema>;
export type RoadmapMessage = z.infer<typeof roadmapMessageSchema>;
